/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getApplicationOverrides';

export type GetApplicationPathParams = NonNullable<operations['getApplication']['parameters']['path']>;

export type GetApplicationQueryParams = NonNullable<operations['getApplication']['parameters']['query']>;

export interface Input extends GetApplicationPathParams {
  apiVersion?: string;
  query?: GetApplicationQueryParams;
}

export async function getApplication(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/applications/{applicationKey}', {
    params: { path, query },
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
